import styled from 'styled-components';
import AntdModal from '../../../AntdModal';

const StyledActivateCardModal = styled(AntdModal)`
  .ant-alert {
    align-items: baseline;
  }

  .ReactCollapse--collapse {
    &[aria-hidden='false'] {
      margin-bottom: 16px;
    }
  }
`;

export {
  StyledActivateCardModal
}
